export default "__VITE_ASSET__556f5ab5__"